<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>

*{
    padding: 0;
    margin: 0;
    font-family: "Microsoft YaHei", "微软雅黑", "SimSun", "宋体", sans-serif;
}


/* 清除所有 a 标签的默认样式 */
a {
    /* 清除下划线 */
    text-decoration: none;
    /* 清除默认文字颜色（继承父元素颜色） */
    color: skyblue;
    /* 清除点击时的焦点轮廓（可选，根据交互需求保留） */
    outline: none;
    /* 清除活跃状态（点击时）的默认样式 */
    -webkit-tap-highlight-color: transparent; /* 清除移动端点击时的高亮背景 */
}

/* 可选：清除 visited（已访问）状态的颜色变化 */
a:visited {
    color: inherit;
}

/* 可选：添加自定义 hover（悬停）效果（替代默认样式） */
a:hover {
    /* 例如：轻微变色或下划线 */
    color: #7F7FD5;
    text-decoration: underline;
}
</style>
